import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from '../menu-item';
import { MenuVisibilityService } from '../Services/menu-visibility.service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

interface AdminCard {
  title: string;
  description: string;
  route: string;
  icon: string;
}

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})
export class AdminComponent implements OnInit {

  adminCards: AdminCard[] = [
    { title: 'Distributors',  description: 'Manage lumber & supply distributors', route: '/distributor-grid', icon: 'warehouse'           },
    { title: 'Materials',     description: 'View and edit material catalog',       route: '/materials',        icon: 'category'            },
    { title: 'Equipment',     description: 'Manage equipment inventory',           route: '/equipment',        icon: 'precision_manufacturing' },
    { title: 'Contractors',   description: 'Browse and manage contractors',        route: '/contractors',      icon: 'engineering'         },
    { title: 'Manufacturers', description: 'Manage manufacturer records',          route: '/manufacturers',    icon: 'factory'             },
    { title: 'Questionnaire', description: 'Review submitted questionnaires',      route: '/questionnaire',    icon: 'quiz'                },
    { title: 'Users',         description: 'Manage application users',             route: '/admin/users',      icon: 'manage_accounts'     },
  ];

  get providerItems(): MenuItem[] { return this.menuService.providerMenuItems; }
  get customerItems(): MenuItem[] { return this.menuService.customerMenuItems; }

  constructor(
    private router: Router,
    public menuService: MenuVisibilityService
  ) {}

  ngOnInit(): void {}

  navigate(route: string): void {
    this.router.navigate([route]);
  }

  isVisibleForRole(role: string, item: MenuItem): boolean {
    return this.menuService.isVisibleForRole(role, item.routerlink);
  }

  onToggle(role: string, item: MenuItem, event: MatSlideToggleChange): void {
    this.menuService.setVisibleForRole(role, item.routerlink, event.checked);
  }
}
